<script lang="ts">
  import moment from "moment";
  import Litepicker from "litepicker/dist/js/main.nocss";
  import PopoverWithButton from "./Popover/PopoverWithButton.svelte";
  import type { PopoverAlignmentOptions } from "@shared/types/PopoverWithButton";
  // @ts-ignore
  export let startDate: string | number | Date = "";
  export let defaultButtonLabel: string;
  export let minWidth: string;
  export let position: string = "";
  export let dateFormat: string;
  export let labelOnly: boolean = false;
  export let altButtonFormat: string = null;
  export let iconType: string = "CalendarToday";
  export let iconSize: string = "20";
  export let buttonMode: boolean = false;
  export let maxDate: string | Date | null = null;
  export let minDate: string | Date | null = null;
  export let selectDateCallback: (
    selectedDate: string | number | Date
  ) => void = selectedDate => {};
  export let disabled: boolean = false;
  export let alignmentOptions: PopoverAlignmentOptions = {
    desktop: { xPosition: "left" },
    mobile: { xPosition: "left" },
  };

  let chosenDate: string | number | Date = startDate;
  let picker: any;
  let singleDatePicker: any;
  let showPopover: boolean = false;

  function openPopover() {
    if (labelOnly) return;

    showPopover = !showPopover;
    showDatepicker();
  }

  function formatDate(d: string | number | Date) {
    // @ts-ignore
    return moment(d, dateFormat).format(dateFormat).toString();
  }

  function select(date: string) {
    chosenDate = formatDate(date);
    if (!buttonMode) {
      apply();
    }
  }

  $: showDatepicker = function () {
    if (!showPopover) return;

    setTimeout(() => {
      picker = new Litepicker({
        element: singleDatePicker,
        startDate: chosenDate,
        singleMode: true,
        inlineMode: true,
        numberOfMonths: 1,
        autoApply: true,
        format: dateFormat,
        numberOfColumns: 1,
        showTooltip: true,
        onSelect: select,
        resetButton: buttonMode,
        minDate: minDate,
        maxDate: maxDate,
      });
    });
  };

  function apply() {
    if (!chosenDate) return;
    chosenDate = formatDate(chosenDate);
    startDate = chosenDate === "Invalid date" ? null : chosenDate;
    selectDateCallback(chosenDate);

    showPopover = false;
  }

  function clear() {
    startDate = null;
    chosenDate = null;
    selectDateCallback(chosenDate);

    showPopover = false;
  }

  $: labelForButton = function () {
    if (!startDate) {
      return defaultButtonLabel;
    } else if (altButtonFormat) {
      return moment(startDate, dateFormat).format(altButtonFormat).toString();
    }
    return `${formatDate(startDate)}`;
  };

</script>

<PopoverWithButton
  bind:show={showPopover}
  bind:buttonDisabled={disabled}
  arrow={false}
  buttonLabel={labelForButton()}
  {openPopover}
  {minWidth}
  {position}
  icon={{ type: iconType, width: iconSize, height: iconSize }}
  customButtonStyle={"font-weight: 400; color: #000;"}
  {alignmentOptions}
>
  <div style="padding: 16px;">
    <div bind:this={singleDatePicker} class:fizz-stack-16={!buttonMode} />
    {#if buttonMode}
      <div class="fizz-flex-row-responsive fizz-space-between fizz-stack-16 fizz-justify-end">
        <div style="padding-top: 20px;">
          <button
            class="fizz-button-secondary float-right"
            style="margin-left: 20px;"
            on:click={apply}
            disabled={!chosenDate}
          >
            Apply
          </button>
          <button class="fizz-button float-right" on:click={clear}> Clear </button>
        </div>
      </div>
    {/if}
  </div>
</PopoverWithButton>
